import React, { useEffect } from "react";
import { Switch, Redirect } from "react-router-dom";
import PrivateRoute from "hoc/Routes/PrivateRoute/PrivateRoute";
import { useSelector } from "react-redux";
import Profile from "./Profile/Profile";
import TopMenu from "Components/TopMenu/TopMenu";
import Yaragh from "./Yaragh/Yaragh";
import Shishe from "./Shishe/Shishe";
import Tori from "./Tori/Tori";
import FomMastik from "./FomMastik/FomMastik";
import Khadamat from "./Khadamat/Khadamat";
import Rokub from "./Rokub/Rokub";
import { propertiesMenuItems } from "Constants/propertiesMenuItems";
import { read } from "Helpers/LocalStorage";
import { useState } from "react";
import { useTranslation } from "react-i18next";

function Properties() {
  const { t } = useTranslation();
  const [noSub, setNoSub] = useState(true);
  const { isLoggedIn } = useSelector((state) => ({
    isLoggedIn: state.auth.isLoggedIn,
  }));

  let updatePropertiesMenuItems = [...propertiesMenuItems];
  propertiesMenuItems.map((item) => {
    if (item.menu_title === "services") {
      item.active = read("khadamatRules");
      return null;
    }
    if (item.menu_title === "FoamMastic") {
      item.active = read("fomMasticRules");
      return null;
    }
    if (item.menu_title === "rokob") {
      item.active = read("rokubRules");
      return null;
    }
    if (item.menu_title === "shishe") {
      item.active = read("mahsoleShisheRules");
      return null;
    }
    if (item.menu_title === "tori") {
      item.active = read("toriRules");
      return null;
    }
    if (item.menu_title === "yaragh") {
      item.active = read("yaraghRules");
      return null;
    }
    if (item.menu_title === "profile") {
      item.active = read("addSeriProfileRules");
      return null;
    }
  });

  useEffect(() => {
    const pathname = window.location.pathname.split("/");
    if (!pathname[3]) setNoSub(true);
    else setNoSub(false);
  }, [window.location.pathname]);

  return (
    <div className="properties">
      {noSub && (
        <div className="properties-alert-dialog">
          <div className="alert alert-warning text-center">
            <span>{t("noSelectedProperties")}</span>
          </div>
        </div>
      )}
      <TopMenu
        menuItems={updatePropertiesMenuItems.filter((item) => item.active)}
        wrap={noSub}
      />
      <div className="propertiesContent">
        <Switch>
          {/*  <Redirect
            exact
            from="/dashboard/properties"
            to="/dashboard/properties/profile"
          /> */}
          <PrivateRoute
            exact
            path="/dashboard/properties/profile"
            component={Profile}
            isLoggedIn={isLoggedIn}
          />
          <PrivateRoute
            exact
            path="/dashboard/properties/fitting"
            component={Yaragh}
            isLoggedIn={isLoggedIn}
          />
          <PrivateRoute
            exact
            path="/dashboard/properties/glass"
            component={Shishe}
            isLoggedIn={isLoggedIn}
          />
          <PrivateRoute
            exact
            path="/dashboard/properties/net"
            component={Tori}
            isLoggedIn={isLoggedIn}
          />
          <PrivateRoute
            exact
            path="/dashboard/properties/other"
            component={FomMastik}
            isLoggedIn={isLoggedIn}
          />
          <PrivateRoute
            exact
            path="/dashboard/properties/service"
            component={Khadamat}
            isLoggedIn={isLoggedIn}
          />
          <PrivateRoute
            exact
            path="/dashboard/properties/flashing"
            component={Rokub}
            isLoggedIn={isLoggedIn}
          />
        </Switch>
      </div>
    </div>
  );
}
export default Properties;
